module.exports = __webpack_public_path__ + "img/logo-paypal.95f86ca2.jpg";